import React from "react";
import Typography from '@material-ui/core/Typography';

export default function AboutUs() {
  return (
    <section id="about" className="about">
      <div className="container aos-init aos-animate" data-aos="fade-up">

        <div className="section-title">
          <h2>About</h2>
          <p>About Us</p>
        </div>

        <div className="row">
          <div className="col-lg-12 order-1 order-lg-2 aos-init aos-animate" data-aos="fade-left" data-aos-delay="100">
          </div>
          <div className="col-lg-12 pt-4 pt-lg-0 order-2 order-lg-1 content">
            <h3>ARA Learning Academy sole purpose is to “educate” every child in
              unique fashion.</h3>
            <p className="font-italic">
              We at ARA , apart from teaching, will guide every
              individuals to become productive. Our courses are at very affordable
              rates. I request everyone to trust us once This academy was founded by
              Engineers & Management students . They saw our youth are very
              talented but didn’t get right platform to work upon. No one talks about
              different field available, new opportunities available etc. Everyone can
              earn money for nation when they are shaped in proper direction by
              engaging student in every possible fields. This makes student to make
              decisions in specific fields after analysing every field. We know every
              institutions make different promises, we here just ask you to come to our
              platform & decide. We are here to create differences. How we are
              doing?, How we will do?, Any plan?
            </p>
            <h3>To know this, come to our platforms. Chef never
            reveals his/her secrets.</h3>
            <p className="font-italic">
              Our teachers are Colleges student from IITs, Nits & other recognised colleges, School heads, Research Scholar & even entrepreneurs.
              Wonder why. We selected those teachers who have passion to teach, develops skill in student, creating excitement about topics &
              management team to give your real life counselling.
</p>
            <h3>Wondering why to chose us?</h3>
            <p className="font-italic">ARA Learning Academy sole purpose is to “educate” every child in
            unique fashion. We at ARA , apart from teaching, will guide every
            individuals to become productive. Our courses are at very affordable

            rates. I request everyone to trust us once This academy was founded
            by Engineers & Management students . They saw our youth are very
            talented but didn’t get right platform to work upon. No one talks
            about different field available, new opportunities available etc.
            Everyone can earn money for nation when they are shaped in proper
            direction by engaging student in every possible fields. This makes
            student to make decisions in specific fields after analysing every field.
            We know every institutions make different promises, we here just ask
            you to come to our platform & decide. We are here to create
            differences. How we are doing?, How we will do?, Any plan?

            To know this, come to our platforms. Chef never reveals his/her
            secrets.

            Our teachers are Colleges student from IITs, Nits & other recognised
            colleges, School heads, Research Scholar & even entrepreneurs.
            Wonder why. We selected those teachers who have passion to teach,
            develops skill in student, creating excitement about topics &
            management team to give your real life counselling.</p>
            {/* <a href="" className="learn-more-btn">Learn More</a> */}
          </div>
        </div>

      {/* <img src="assets/img/about.jpg" width="100" height="100" className="img-fluid" alt="" /> */}
      <p><h5 style={{ marginTop: "10px"}}>ARA Learning Academy</h5>
      <Typography variant="caption" display="block" gutterBottom>
      "Efforts brings Quality, Quality brings Success"
      </Typography></p>
      </div>
    </section>
  );
}